import { CardProps } from '../container-menu'

export enum LayoutStyle {
    Org = 0,
    List = 1
}

export type CreateTreeNode = {
    data: {
        layoutStyle: LayoutStyle
        parent: string
        [key: string]: any
    }
}

export type TreeNode = {
    data: {
        id: string
        layoutStyle: LayoutStyle
        parent: string
        [key: string]: any
    }
}

export interface NodeProps {
    actions?: UseDndTreeActionsProps
    isActive: boolean
    isDraggedNode: boolean
    treeModes: TreeModes
    node: TreeNode
    onNodeClicked: (nodeId: string) => void
    treeOptions?: TreeOptions
    DragHandle: React.FC<DragHandleWrapperProps>
}

export type TreeNodeUnflattened =
    | (TreeNode & { children: TreeNodeUnflattened[] })
    | null
// { id: string; type: LayoutStyle; [key: string]: any }

export type TreeNodesUnflattened = TreeNodeUnflattened[]
export type TreeNodes = TreeNode[]

export type TreeBranch = {
    id: string
    children?: TreeBranch[]
}

export type TreeData = {
    nodes: TreeNodes
    // tree: TreeBranch[]
}

export type TreeDataUnflattened = {
    nodes: TreeNodesUnflattened
    // tree: TreeBranch[]
}

export interface NodeWrapperProps {
    actions: UseDndTreeActionsProps
    treeOptions?: TreeOptions
    treeModes: TreeModes
    expanded?: boolean
    node: TreeNodeUnflattened
    isChildOfOrg: boolean
    isFirstChild: boolean
    isLastChild: boolean
    isList: boolean
    hasParent: boolean
    hasChildren: boolean
}

export type AddChildNodeServerFn = (args: {
    component: string
    newComponent?: string
}) => void
export type DeleteNodeServerFn = (nodeId: string) => void
export type InsertSiblingBeforeServerFn = (args: {
    component: string
    newComponent?: string
}) => void
export type InsertSiblingAfterServerFn = (args: {
    component: string
    newComponent?: string
}) => void
export type InsertParentServerFn = (args: {
    component: string
    newComponent?: string
}) => void
export type MoveNodeServerFn = (args: {
    nodeKey: string
    index: number
    parentKey: string
}) => void

export type CreateNewNodeFn = (args: CreateTreeNode) => TreeNode
export type AddChildNodeFn = (node: TreeNode | TreeNodeUnflattened) => void
export type DeleteNodeFn = (nodeId: string) => void
export type InsertSiblingBeforeFn = (
    beforeNode: TreeNode | TreeNodeUnflattened
) => void
export type InsertSiblingAfterFn = (
    afterNode: TreeNode | TreeNodeUnflattened
) => void
export type InsertParentFn = (nodeId: string) => void

export type MoveNodeFn = (args: {
    droppedNode: TreeNodeUnflattened
    parentContainerNode: TreeNodeUnflattened
    index: number
}) => void

export type SetNodeDraggingIdFn = (nodeId: string | null) => void

export interface DnDTreesActionsProps {
    addChildNode?: AddChildNodeServerFn
    createNewNode?: CreateNewNodeFn
    deleteNode?: DeleteNodeServerFn
    insertSiblingBefore?: InsertSiblingBeforeServerFn
    insertParent?: InsertParentServerFn
    insertSiblingAfter?: InsertSiblingAfterServerFn
    moveNode?: MoveNodeServerFn
    setNodeDraggingId?: SetNodeDraggingIdFn
}

export interface UseDndTreeActionsProps {
    collapseNode: (nodeId: string) => void
    expandNode: (nodeId: string) => void
    toggleNode: (nodeId: string) => void
    addChildNode: AddChildNodeFn
    createNewNode: CreateNewNodeFn
    deleteNode: DeleteNodeFn
    insertSiblingBefore: InsertSiblingBeforeFn
    insertParent: InsertParentFn
    insertSiblingAfter: InsertSiblingAfterFn
    moveNode: MoveNodeFn
    setNodeDraggingId: SetNodeDraggingIdFn
}

export type TreeOptions = {
    canExpandCollapse?: boolean
    canEditTreeStructure?: boolean
}

export type TreeModes = {
    dragDropMode: boolean
}

export type Modes = {
    treeModes: TreeModes
    actions: {
        setDragDropMode: (dragDrop: boolean) => void
    }
}

export interface DnDTreesProps {
    actions?: DnDTreesActionsProps
    treeData: TreeData
    components: {
        TreeMenu?: { Menu: React.FC<any>; cardProps?: CardProps }
        Node: React.FC<NodeProps>
    }
    treeOptions?: TreeOptions
    onNodeClicked?: (nodeId: string) => void
    activeNode?: string
}

export interface DragHandleWrapperProps {
    isDraggedNode: boolean
    nodeId: string
    handle?: JSX.Element
}
